import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '@/shared/hooks/redux';
import { hasStaffRole } from '@/shared/utils/authUtils';

interface StaffRouteProps {
  children: ReactNode;
}

export const StaffRoute = ({ children }: StaffRouteProps) => {
  const { isAuthenticated, isInitialized, token } = useAppSelector((state) => state.auth);
  const location = useLocation();

  if (!isInitialized) {
    return (
      <div style={{ display: 'grid', minHeight: '100vh', placeItems: 'center' }}>Carregando...</div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!hasStaffRole(token)) {
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
};
